import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import moment from 'moment-timezone'
import { Modal } from 'antd'

import { GET_SERVER_TIME } from '../Appointment/helper'
import { useTranslation, useLanguageQuery } from 'next-export-i18n'
import PrivacyPolicy from './PrivacyPolicy'

import { validationFullFormSchema } from '../Appointment/validate'
import Terms from './Terms'

const Header = () => {
  const router = useRouter()
  const { t } = useTranslation()
  const [query] = useLanguageQuery()

  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [consentChecked, setConsentChecked] = useState(false)
  const [behaviourChecked, setBehaviourChecked] = useState(false)
  const [fulfillmentChecked, setFulfillmentChecked] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [privacyChecked, setPrivacyChecked] = useState(false)
  const [termsChecked, setTermsChecked] = useState(false)

  const [postalCode, setPostalCode] = useState('')
  const [postalCodeValidated, setPostalCodeValidated] = useState(false)
  const [postalCodeError, setPostalCodeError] = useState('')

  const [openModal, setOpenModal] = useState(false)

  // Get the postal_code validation from the full form schema
  const postalCodeValidation = validationFullFormSchema.fields.postal_code

  const handlePostalCodeChange = (event) => {
    setPostalCode(event.target.value)
  }

  // Local check for Toronto postal code to toggle Modal
  const validatePostalCode = async () => {
    try {
      await postalCodeValidation.validate(postalCode)
      setPostalCodeError('') // Clear any previous error
      setPostalCodeValidated(true)
    } catch (error) {
      setPostalCodeError(error.message)
      if (
        error.message === 'Postal code outside of service area' ||
        'Post code outside of service area (Toronto)'
      ) {
        setOpenModal(true)
      }
    }
  }

  const handleClick = async () => {
    try {
      const response = await fetch(GET_SERVER_TIME)
      const data = await response.json()
      const serverTime = moment(data.time).tz('America/New_York')

      if (serverTime.hour() >= 20 && serverTime.hour() <= 24) {
        // Between 8pm and 12am, open the modal
        setModalIsOpen(true)
      } else {
        // Otherwise, go to the registration page
        router.push('/register')
      }
    } catch (error) {
      console.log('Error', error)
    }
  }

  // Enable the button when all checkboxes are checked and postal code is validated
  useEffect(() => {
    if (
      consentChecked &&
      // behaviourChecked &&
      // fulfillmentChecked &&
      // privacyChecked &&
      // termsChecked &&
      postalCodeValidated
    ) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [
    consentChecked,
    // behaviourChecked,
    // fulfillmentChecked,
    // privacyChecked,
    // termsChecked,
    postalCodeValidated,
  ])

  return (
    <div>
      <div className="w-full bg-white relative ">
        <div className="flex  max-w-7xl  mx-auto pb-10 px-4 md:px-4 mt-28 md:mt-6 xl:mt-0">
          <div className="self-auto md:self-center">
            <h2 className="text-secondary text-xl md:text-2xl xl:text-4xl md:pt-14 text-center md:text-left font-semibold pb-2 md:pb-8   ">
              {/* {t('consent')} */}
              Postal Code Verification
            </h2>
            <p className="text-base xl:text-xl pt-8 md:mr-12 text-center md:text-left font-semibold  ">
              {/* {t('agreement_to_all')} */}
              {postalCodeValidated
                ? 'Thank you for verifying your postal code.'
                : 'Verify your postal code to ensure you are within our service area'}
            </p>
            <div className=" items-center grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-6 relative mb-6">
              <div>
                <label className="block capitalize text-base pb-3 text-lb">
                  {/* {t('postal_code')} */}
                  {!postalCodeValidated
                    ? 'Verify your postal code to continue'
                    : 'Continue to the Consent section below'}
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="postal_code"
                    onChange={handlePostalCodeChange}
                    value={postalCode}
                    placeholder={t('postal_code')}
                    className="px-4 py-3 mb-8 bg-inp w-full rounded-md focus-within:outline-none border-2 border-gray-300"
                  />
                  {postalCodeError && (
                    <span className="absolute text-red-500 left-0 top-14">
                      {postalCodeError}
                    </span>
                  )}
                </div>
              </div>
              <div>
                <button
                  className="flex"
                  onClick={validatePostalCode}
                  type="button"
                  disabled={postalCodeValidated}
                >
                  <span
                    className={`text-base w-full md:w-auto text-center font-semibold text-white  bg-primary transition-all rounded-md px-16 py-3 cursor-pointer ${
                      postalCodeValidated
                        ? 'opacity-50 cursor-not-allowed bg-secondary'
                        : 'hover:text-white hover:bg-secondary hover:shadow-lg'
                    }`}
                  >
                    {/* {postalCodeValidated ? "Verify" : "Success"} */}
                    {postalCodeValidated ? 'Thank You' : 'Verify'}
                  </span>
                </button>
              </div>
            </div>
            <h2 className="text-secondary text-xl md:text-2xl xl:text-4xl md:pt-6 text-center md:text-left font-semibold pb-2 md:pb-8   ">
              {t('consent')}
            </h2>
            <p className=" md:max-w-lg text-base xl:text-xl pb-16 md:mr-12 text-center md:text-left font-semibold  ">
              {t('agreement_to_all')}
            </p>

            {/* Your privacy section */}
            <div className="grid  grid-cols-1  gap-4 md:gap-12 relative">
              <div>
                <div>
                  <h2 className="text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold   ">
                    {t('your_privacy')}
                  </h2>
                  <p className=" text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    {t('i_consent')}
                  </p>
                  <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    {t('i_am_aware')}
                  </p>
                  <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    {t('i_understand')}
                  </p>
                  <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    {t('we_care_about_your_privacy')}
                  </p>
                  <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
                    {t('by_ticking')}
                  </p>
                </div>
              </div>

              {/* Aggressive behaviour section */}
              <div className="">
                <div>
                  <h2
                    className={`text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold
                    }`}
                  >
                    {t('aggressive_behaviour')}
                  </h2>
                  <p
                    className={`text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal
                    }`}
                  >
                    {t('here_at_the_east_region_virtual_care_clinic')}
                  </p>
                  <p
                    className={`text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal
                    `}
                  >
                    {t('we_appreciate_your_cooperation')}
                  </p>
                </div>
              </div>

              {/* What happens if your appointment starts section */}
              <div className="">
                <div>
                  <h2
                    className={`text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold
                    `}
                  >
                    {t('what_happens_if_your_appointment_starts')}
                  </h2>
                  <p
                    className={`text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal
                    }`}
                  >
                    {t('during_the_course')}
                  </p>
                  <p
                    className={`text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal
                    }`}
                  >
                    {t('we_appreciate_your_understanding')}
                  </p>
                  <p
                    className={`text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal
                    }`}
                  >
                    {t('thank_you_for_your_cooperation')}
                  </p>
                </div>
              </div>

              {/* Privacy Policy section */}
              <div className="">
                <div>
                  <h2
                    className={`text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-6  text-center md:text-left font-semibold
                    }`}
                  >
                    Terms of Service & Privacy Policy
                  </h2>
                  <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal">
                    <a
                      href="https://www.healthespresso.com/privacy-policy"
                      target="_blank"
                    >
                      https://www.healthespresso.com/privacy-policy
                    </a>
                    <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal">
                      <a
                        href="https://www.healthespresso.com/terms-of-service"
                        target="_blank"
                      >
                        https://www.healthespresso.com/terms-of-service
                      </a>
                    </p>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Terms and Services section */}
      <div className="w-full ">
        <div className="max-w-7xl mx-auto px-4 py-10 md:py-14">
          {/* <h2
            className={`text-woundTextDark text-xl md:text-2xl xl:text-2xl pb-3  text-center md:text-left font-semibold
            }`}
          >
            Terms of Service
          </h2>
          <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal">
            <a href="https://www.healthespresso.com/terms-of-service" target="_blank">
              https://www.healthespresso.com/terms-of-service
            </a>
          </p> */}
          <p className="text-base xl:text-xl pb-4 md:mr-12 text-center md:text-left font-normal  ">
            {t('by_ticking')}
          </p>
          <div className="flex items-center justify-center md:justify-start border-t border-gray-500  md:pt-2 md:mt-2">
            <input
              type="checkbox"
              id="consent"
              name="consent"
              className="mr-2"
              checked={consentChecked}
              onChange={() => setConsentChecked(!consentChecked)}
            />
            <label
              htmlFor="consent"
              className={`text-base xl:text-xl font-normal ${
                consentChecked ? 'text-secondary' : 'text-primary'
              }`}
            >
              {t('i_agree')}
            </label>
          </div>

          {buttonDisabled && (
            <div className="pt-6">
              <p className="text-red-500">
                Please review this page and agree to all terms and conditions
                listed above:
              </p>
              {!postalCodeValidated && (
                <p className="text-red-500">Validate your Postal Code</p>
              )}
              {!consentChecked && (
                <p className="text-red-500">Consent is required</p>
              )}
            </div>
          )}
          <div className="mt-9 md:w-40">
            <button
              disabled={buttonDisabled}
              onClick={handleClick}
              className={`text-sm text-center lg:text-lg font-semibold text-white bg-primary transition-all rounded-full px-5 py-3 md:px-10 md:py-3.5 cursor-pointer ${
                buttonDisabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:text-white hover:bg-secondary hover:shadow-lg'
              }`}
            >
              {t('register.text')}
            </button>

            <Modal
              title="We're almost closed!"
              open={modalIsOpen}
              onOk={() => {
                setModalIsOpen(false)
                router.push('/register')
              }}
              onCancel={() => setModalIsOpen(false)}
            >
              <p>Any requests after 8pm will be processed the next day</p>
            </Modal>
            <Modal
              title="You're outside of our service area"
              open={openModal}
              onCancel={() => {
                setPostalCode('')
                setPostalCodeError('')
                setOpenModal(false)
              }}
              onOk={() => {
                setPostalCode('')
                setPostalCodeError('')
                setOpenModal(false)
              }}
            >
              <p>
                We're sorry, but you appear outside of our service area. The
                North West Region Virtual Care Clinic covers areas from Kenora
                to Manitouwadge and Thunder Bay to Fort Severn.. If you are in
                this area, please verify the postal code you entered.
              </p>
              {postalCodeError ===
                'Postal code outside of service area (Toronto)' && (
                <p className="pt-4">
                  If you are in the Toronto area, please visit{' '}
                  <a
                    className="text-secondary hover:text-primary"
                    href="https://www.torontovirtualed.ca/"
                    target="_blank"
                  >
                    Toronto’s Virtual Emergency Department
                  </a>{' '}
                  provided by Sunnybrook Hospital & University Health Network or
                  call 811 for telehealth services.
                </p>
              )}
              {postalCodeError ===
                'Postal code outside of service area (Ontario North East)' && (
                <p className="pt-4">
                  If you are in North Eastern Ontario, please visit{' '}
                  <a
                    className="text-secondary hover:text-primary"
                    href="https://www.nevirtualcare.ca/"
                    target="_blank"
                  >
                    North East Region Virtual Care Clinic
                  </a>{' '}
                  The North East Virtual Care Clinic is a Nurse Practitioner-led
                  virtual care clinic that works with local health care
                  providers to ensure patients can access more timely care.
                </p>
              )}
              {postalCodeError ===
                'Postal code outside of service area (Ontario East)' && (
                <p className="pt-4">
                  If you are in Eastern Ontario, please visit{' '}
                  <a
                    className="text-secondary hover:text-primary"
                    href="https://www.virtualcareontario.ca/"
                    target="_blank"
                  >
                    East Region Virtual Care Clinic
                  </a>{' '}
                  The East Region Virtual Care Clinic is a Nurse
                  Practitioner-led virtual care clinic that works with local
                  health care providers to ensure patients can access more
                  timely care.
                </p>
              )}
              <p className="pt-4">
                To learn more about virtual care clinics that might serve your
                area, please contact Health 811 at 1-866-797-0007.
              </p>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
